
<ng-container *ngIf="!error && comments">
    <!-- Comments Section -->
    <div class="comments-section">
      <div class="comments-header"> 
        <h3>Comments ({{ comments.length }})</h3>
      </div>
      
      <div *ngIf="isLoadingComments" class="loading-container">
        <nz-spin nzTip="Loading comments..."></nz-spin>
      </div>
      
      <div *ngIf="errorComments && !isLoadingComments" class="mb-3">
        <nz-alert nzType="warning" [nzMessage]="errorComments" nzShowIcon></nz-alert>
      </div>
      
      <div class="comments-list" *ngIf="!isLoadingComments && comments.length > 0">
        <nz-list [nzDataSource]="comments" [nzRenderItem]="commentTemplate" [nzItemLayout]="'horizontal'">
          <ng-template #commentTemplate let-item>
            <nz-comment 
              [nzAuthor]="item.commenter.commenterName" 
              [nzDatetime]="formatDatetime(item.createdAt)">
              <!--<nz-avatar nzText="U" style="color:#f56a00; background-color:#fde3cf;"></nz-avatar>-->
              <nz-avatar 
                nz-comment-avatar 
                [nzText]="getInitials(item.commenter.commenterName)">
              </nz-avatar>
              <nz-comment-content>
                <p>{{ item.text }}</p>
              </nz-comment-content>
              <nz-comment-action *ngIf="item.likesCount > 0 && item.likesCount != null">
                <span>
                  <i nz-icon nzType="like" nzTheme="outline"></i>
                  <span class="comment-action">{{ item.likesCount}} likes</span>
                </span>
              </nz-comment-action>
              <nz-comment-action *ngIf="item.commentUrl">
                <a [href]="item.commentUrl" target="_blank">
                  <i nz-icon nzType="link" nzTheme="outline"></i>
                </a>
              </nz-comment-action>
            </nz-comment>
            <nz-divider></nz-divider>
          </ng-template>
        </nz-list>
      </div>
      
      <div *ngIf="comments.length == 0 && !errorComments && !isLoadingComments" class="no-comments">
        <nz-empty nzDescription="No comments found for this post"></nz-empty>
      </div>
    </div>
</ng-container>
